import styled from "styled-components";

export const View = styled.div`
  .hidden {
    display: none;
  }

  #download-example-file:visited {
    color: blue;
  }
  .csv-field {
    p:nth-child(2) {
      opacity: 0.5;
    }
  }
  .MuiTextField-root {
    label {
      width: 85%;
      font-size: 14px;
    }
  }
  .filds-container {
    width: 256px;
    min-width: 256px;
  }
  .css-1d1r5q-MuiFormHelperText-root{
    color: #d32f2f;
  }

  .container-input-kit {
    font-family: "Roboto", "Arial", sans-serif;
    p {
      color: rgba(0, 0, 0, 0.6);
      font-size: 12px;
      padding: 0 12px;
      margin-bottom: -1px;
    }
    .input-kit {
    display: flex;
    align-items: center;
    min-width: 232px;
    height: 32px;
    font-weight: 400;
    border-bottom: 1px dotted rgba(0, 0, 0, 0.4);
    font-size: 16px;
    padding: 0 12px;
    color: rgba(0, 0, 0, 0.38);
    margin-bottom: 15px;
  }
  }

  .button {
    margin: 10px 0px;
  }
`;
